import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import batchUserStatuses from '../../constants/BatchUserStatuses';
import batchUserTypeProcess from '../../constants/BatchUserTypeProcess';

const styles = {
  root: {
    backgroundColor: '#fff'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  headerLabel: {
    fontWeight: '500'
  },
  overflow: {
    overflow: 'auto'
  },
  error: {
    width: '100px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      listBatchUser: state.users.listBatchUser
        ? state.users.listBatchUser.list
        : [],
      totalCount: state.users.listBatchUser
        ? state.users.listBatchUser.count
        : 0
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('checked', 'setChecked', () => {
    return new Map();
  }),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    listBatchUser,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage
  }) => {
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>一括登録ID</TableCell>
                <TableCell>ユーザID</TableCell>
                <TableCell>メールアドレス</TableCell>
                <TableCell>インポート日時</TableCell>
                <TableCell>実施日時</TableCell>
                <TableCell>処理内容</TableCell>
                <TableCell>ステータス</TableCell>
                <TableCell className={classes.error}>
                  エラーメッセージ
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listBatchUser &&
                listBatchUser.map(listUser => (
                  <TableRow>
                    <TableCell>{listUser.batchLogId}</TableCell>
                    <TableCell>{listUser.userId}</TableCell>
                    <TableCell>{listUser.email}</TableCell>
                    <TableCell>{listUser.createdAt}</TableCell>
                    <TableCell>{listUser.executeDate}</TableCell>
                    <TableCell>
                      {batchUserTypeProcess.map(item => {
                        return item.value === listUser.typeProcess
                          ? item.name
                          : '';
                      })}
                    </TableCell>
                    <TableCell>
                      {batchUserStatuses.map(item => {
                        return item.value === listUser.status ? item.name : '';
                      })}
                    </TableCell>
                    <TableCell>{listUser.errorMessage}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
        <div>
          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={page}
            handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
            limit={rowsPerPage}
            totalCount={totalCount}
            setLimit={setRowsPerPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
